import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronDown, ShoppingCart } from "lucide-react";
import { useCart } from "../../contexts/CartContext";
import styles from "./Navbar.module.css";

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobileProductsOpen, setIsMobileProductsOpen] = useState(false);
  const location = useLocation();
  const { getCartCount } = useCart();
  const cartCount = getCartCount();

  const navItems = [
    { id: "home", label: "Home", path: "/" },
    {
      id: "products",
      label: "Products",
      path: "/products",
      hasDropdown: true,
      dropdownItems: [
        // { label: "All Products", path: "/products" },
        { label: "Paint By Number Kits", path: "/products/kits" },
        { label: "Custom Orders", path: "/products/custom" },
        { label: "Color Palettes", path: "/products/palettes" },
        { label: "Workshops", path: "/products/workshops" },
      ],
    },
    { id: "about", label: "About", path: "/about" },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.container}>
          <div className={styles.navContent}>
            {/* Logo */}
            <Link to="/" className={styles.logo}>
              {/* <Palette className={styles.logoIcon} />
            <span className={styles.logoText}>Paint by Numbers</span> */}
              <img
                src="/ARTSYICILE_NEW_LOGO.png"
                alt="Artsy Icile"
                className={styles.logoImage}
              />
            </Link>

            {/* Desktop Navigation */}
            <div className={styles.desktopNav}>
              {navItems.map((item) =>
                item.hasDropdown ? (
                  <div key={item.id} className={styles.dropdown}>
                    <Link
                      to={item.path}
                      className={`${styles.navLink} ${isActive(item.path) ? styles.active : ""}`}
                    >
                      {item.label}
                      <ChevronDown size={16} className={styles.chevron} />
                    </Link>
                    <div className={styles.dropdownMenu}>
                      {item.dropdownItems?.map((subItem, index) => (
                        <Link
                          key={index}
                          to={subItem.path}
                          className={styles.dropdownItem}
                        >
                          {subItem.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                ) : (
                  <Link
                    key={item.id}
                    to={item.path}
                    className={`${styles.navLink} ${isActive(item.path) ? styles.active : ""}`}
                  >
                    {item.label}
                  </Link>
                ),
              )}
            </div>

            {/* Mobile menu button */}
            <div className={styles.mobileMenuButton}>
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className={styles.menuIcon}
              >
                {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className={styles.mobileNav}>
              {navItems.map((item) =>
                item.hasDropdown ? (
                  <div key={item.id}>
                    <button
                      onClick={() =>
                        setIsMobileProductsOpen(!isMobileProductsOpen)
                      }
                      className={`${styles.mobileNavLink} ${isActive(item.path) ? styles.mobileActive : ""}`}
                    >
                      {item.label}
                      <ChevronDown
                        size={16}
                        className={`${styles.mobileChevron} ${isMobileProductsOpen ? styles.rotated : ""}`}
                      />
                    </button>
                    {isMobileProductsOpen && (
                      <div className={styles.mobileDropdown}>
                        {item.dropdownItems?.map((subItem, index) => (
                          <Link
                            key={index}
                            to={subItem.path}
                            onClick={() => setIsMenuOpen(false)}
                            className={styles.mobileDropdownItem}
                          >
                            {subItem.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    key={item.id}
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`${styles.mobileNavLink} ${isActive(item.path) ? styles.mobileActive : ""}`}
                  >
                    {item.label}
                  </Link>
                ),
              )}
            </div>
          )}
        </div>
      </nav>

      {/* Floating Cart Button - only visible when items in cart */}
      {cartCount > 0 && (
        <Link to="/cart" className={styles.cartButton}>
          <ShoppingCart size={24} />
          <span className={styles.cartBadge}>{cartCount}</span>
        </Link>
      )}
    </>
  );
}
